import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import DataTable from "examples/Tables/DataTable";
import React, { useState, useEffect } from "react";
// Data
import MDButton from "../../components/MDButton";
import CustomerEdit from "./edits/CustomerEdit";
import buildCustomerTable from "./data/customerTableData";
import apis from "../../context/api";

function Customers() {
  const [customerUpdate, setCustomerUpdate] = useState(false);
  const [id, setId] = useState(null);
  const [customerData, setCustomerData] = useState({ columns: [], rows: [] });
  const handleCancel = () => {
    setCustomerUpdate(false);
  };
  const customerUpdated = () => {
    setCustomerUpdate(false);
    loadTableData();
  };
  useEffect(() => {
    loadTableData();
  }, []);
  const editCustomer = (id) => {
    setId(id);
    setCustomerUpdate(true);
  };

  const loadTableData = async () => {
    try {
      apis
        .getCustomers()
        .then((data) => {
          setCustomerData(buildCustomerTable(data, (id) => editCustomer(id)));
        })
        .catch((err) => {
          throw new Error("Can not get Customers");
        });
    } catch (err) {
      console.error("Data loading error:", err);
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      {customerUpdate && (
        <CustomerEdit onSuccess={customerUpdated} v id={id} onCancel={handleCancel} />
      )}
      {!customerUpdate && (
        <MDBox pt={6} pb={6}>
          <Grid container spacing={6}>
            <Grid item xs={12}>
              <Card>
                <MDBox
                  mx={2}
                  mt={-3}
                  py={3}
                  px={2}
                  variant="gradient"
                  bgColor="info"
                  borderRadius="lg"
                  coloredShadow="info"
                >
                  <MDTypography variant="h6" color="white">
                    Customers
                  </MDTypography>
                </MDBox>
                <Grid container justifyContent="flex-end" pr={2} pt={2}>
                  <Grid item>
                    <MDButton
                      variant="gradient"
                      color="info"
                      onClick={() => {
                        setId(null);
                        setCustomerUpdate(true);
                      }}
                    >
                      Create
                    </MDButton>
                  </Grid>
                </Grid>
                <MDBox pt={3}>
                  <DataTable
                    table={{ columns: customerData.columns, rows: customerData.rows }}
                    isSorted={false}
                    entriesPerPage={false}
                    showTotalEntries={false}
                    noEndBorder
                  />
                </MDBox>
              </Card>
            </Grid>
          </Grid>
        </MDBox>
      )}
      <Footer />
    </DashboardLayout>
  );
}

export default Customers;
